export default {
   // -----------Title----------
   information: '信息',
   provideDetailsOfTheProfile: '提供详细信息',
   categoryHierarchy: '分类层级',
   setForFurtherLevelOfCategory: '设置进一步的类别层级',

   // -----------MUI-----------
   children: '个子类别',
   categoryName: '分类名称',
   brandName: '品牌名称',
   uomName: '计量单位名称',
   subCategory: '子分类',

   metricType: '度量类型',
   metricTypeDisplayName: '度量类型名称',
   decimalPlacesDigit: '小数点位数',
};